import { render, staticRenderFns } from "./pos-contact.vue?vue&type=template&id=0ff35e33&"
import script from "./pos-contact.vue?vue&type=script&lang=ts&"
export * from "./pos-contact.vue?vue&type=script&lang=ts&"
import style0 from "./pos-contact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
